import { heroui } from '@heroui/theme';
/** @type {import('tailwindcss').Config} */
export default {
    content: [
        './index.html',
        './src/**/*.{js,ts,jsx,tsx}',
        './node_modules/primereact/**/*.{js,ts,jsx,tsx}',
        './node_modules/@heroui/theme/dist/**/*.{js,ts,jsx,tsx}',
    ],
    theme: {
        extend: {
            // colors: {
            //     'primary-1': '#141414',
            //     'primary-2': '#292929',
            //     'primary-3': '#ffffff',
            //     'primary-4': '#f5f5f5',
            // },
        },
    },
    darkMode: 'class',
    plugins: [
        heroui({
            addCommonColors: true,
            themes: {
                light: {
                    colors: {
                        background: '#FFFFFF',
                        foreground: '#11181C',
                        content1: '#FFFFFF',
                        content2: '#f4f4f5',
                        content3: '#e4e4e7',
                        content4: '#d4d4d8',
                        primary: {
                            50: '#E7E7E7',
                            100: '#F3F3F3',
                            200: '#E7E7E7',
                            300: '#B8B8B8',
                            400: '#727272',
                            500: '#141414',
                            600: '#110E0E',
                            700: '#0E0A0A',
                            800: '#0B0607',
                            900: '#090305',
                            foreground: '#FFFFFF',
                            DEFAULT: '#141414',
                        },
                        secondary: {
                            50: '#E9E9E9',
                            100: '#F4F4F4',
                            200: '#E9E9E9',
                            300: '#BEBEBE',
                            400: '#7E7E7E',
                            500: '#292929',
                            600: '#231D1E',
                            700: '#1D1416',
                            800: '#170D0F',
                            900: '#13070B',
                            foreground: '#FFFFFF',
                            DEFAULT: '#292929',
                        },
                        success: {
                            50: '#C6F9B7',
                            100: '#E5FCDA',
                            200: '#C6F9B7',
                            300: '#9BED8E',
                            400: '#73DB6E',
                            500: '#42C447',
                            600: '#30A83F',
                            700: '#218D38',
                            800: '#157131',
                            900: '#0C5E2C',
                            foreground: '#FFFFFF',
                            DEFAULT: '#42C447',
                        },
                        warning: {
                            50: '#FAF89F',
                            100: '#FCFBCE',
                            200: '#FAF89F',
                            300: '#F0EC6E',
                            400: '#E1DD48',
                            500: '#CEC814',
                            600: '#B1AB0E',
                            700: '#948E0A',
                            800: '#777206',
                            900: '#625E03',
                            foreground: '#FFFFFF',
                            DEFAULT: '#CEC814',
                        },
                        danger: {
                            50: '#FFC9AD',
                            100: '#FFE7D6',
                            200: '#FFC9AD',
                            300: '#FFA483',
                            400: '#FF8165',
                            500: '#FF4732',
                            600: '#DB2824',
                            700: '#B71922',
                            800: '#930F22',
                            900: '#7A0922',
                            foreground: '#FFFFFF',
                            DEFAULT: '#FF4732',
                        },
                    },
                },
            },
        }),
    ],
};
